export default __webpack_public_path__ + "a6c6fea84d5f66aff628b495b5ba8f22.png";